import React, { useEffect, useState } from 'react';
import { useInvoiceContext } from '../../../components/InvoiceProvider';
import Files from '@afosto/app-components-react/Files';
import formatFile from '@afosto/utils-react/files/formatFile';
import { files as filesApi } from '@afosto/content/api/Files';

const InvoiceFiles = () => {
  const [files, setFiles] = useState([]);
  const { invoice } = useInvoiceContext();
  const { file_id: fileId } = invoice ?? {};
  const path = `invoices/${invoice?.id}/files`;

  const fetchFiles = async filePath => {
    try {
      const response = await filesApi.listFiles({
        dir: filePath,
      });

      const { data = [] } = response;

      return data.reduce((acc, fileData) => [...acc, formatFile(fileData)], []);
    } catch (err) {
      return [];
    }
  };

  useEffect(() => {
    let isMounted = true;

    const fetchFile = async id => {
      try {
        if (!id) {
          return null;
        }

        const response = await filesApi.getFile(id);
        return formatFile(response?.data);
      } catch (err) {
        return null;
      }
    };

    const fetchAllFiles = async () => {
      try {
        const pathFiles = await fetchFiles(path);
        const file = await fetchFile(fileId);

        if (isMounted) {
          setFiles([...(file ? [{ ...file, isDeletable: false }] : []), ...pathFiles]);
        }
      } catch (err) {
        if (isMounted) {
          setFiles([]);
        }
      }
    };

    if (path) {
      fetchAllFiles();
    }

    return () => {
      isMounted = false;
    };
  }, [path, fileId]);

  return (
    <Files
      files={files}
      uploadPath={path}
      onRemoveFile={() => fetchFiles(path)}
      onAddFile={() => fetchFiles(path)}
    />
  );
};

export default InvoiceFiles;
